module.exports = __webpack_public_path__ + "teqbahn-assets/media/footer-2_new.031a0c41.png";